

































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
 
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class RuleCtrl extends Vue {
    close() {
        this.$emit("close");
    }
}
